var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSheetsharkIconMainWhite = function SvgSheetsharkIconMainWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.88 104.95"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sheetshark_icon_main_white"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.42,0h-19a4.21,4.21,0,0,0-4.2,4.21V81.38h0V99.07c4.72-1,9.36-2,14.32-2.7A27.77,27.77,0,0,0,82.3,78.6h0A32,32,0,0,0,77.41,67a48,48,0,0,1,15.21,4.45V4.21A4.2,4.2,0,0,0,88.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.37,72.83V44a4.21,4.21,0,0,0-4.21-4.21H4.21A4.22,4.22,0,0,0,0,44V76.91H0v9.51C5.36,90.43,13,97,18.53,105c3.11,0,6-.08,8.84-.2V84.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,67.21V61.15a4.2,4.2,0,0,0-4.21-4.21H36.84a4.22,4.22,0,0,0-4.21,4.21V84.6h0v19.84A193.56,193.56,0,0,0,60,100.22v-18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.25,58.13V28.4A4.21,4.21,0,0,0,121,24.19h-19a4.22,4.22,0,0,0-4.21,4.21V74.58q1.53,1.1,2.91,2.28h0A43.43,43.43,0,0,1,113.08,96c3.79.41,7.82,1,12.17,1.67V81.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.88,99V50.93a4.2,4.2,0,0,0-4.21-4.2h-19a4.21,4.21,0,0,0-4.21,4.2V83.57h0v15c8,1.5,17.07,3.56,27.38,6.3V99Z"
  }))))));
};
export { SvgSheetsharkIconMainWhite as ReactComponent };
export default __webpack_public_path__ + "e896f43eb82366d652317201f440980f.svg";